import { themeGet } from '@styled-system/theme-get';
import styled, { css } from 'styled-components/macro';

import { Box } from '@olist/united';

export const SideMenu = styled(Box)`
  position: relative;
  width: 250px;

  ${(props) => css`
    @media (min-width: ${themeGet('breakpoints')(props)[1]}) {
      position: absolute;
    }
  `}
`;

export const UnqualifedDescription = styled.div`
  color: ${({ theme }) => theme.olist.color.neutral.stronger};
  line-height: 24px;

  strong {
    font-weight: 800;
  }

  ul {
    list-style-type: disc;
    margin-bottom: 24px;
    margin-left: 16px;
    li {
      line-height: 24px;
    }
  }
`;

export const UnqualifedLinkHelp = styled.a``;
